<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<button type="button" data-toggle="tooltip" title="Изтриване" class="btn btn-danger" v-if="canDeleteTopic()" @click="deleteTopic()"><i class="fa fa-close"></i></button>
					<button type="button" data-toggle="tooltip" title="Назад" class="btn btn-success" @click="$router.go(-1)"><i class="fa fa-arrow-left"></i></button>
					<!-- <router-link data-toggle="tooltip" title="Добави" class="btn btn-success" to=""><i class="fa fa-plus"></i></router-link> -->
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid">

		<div v-if="error">
			<div class="alert alert-danger alert-with-icon text-center">
				<h4><i class="fa fa-bell"></i></h4>
				<p>
					Нямате достъп до тази тема!
				</p>
			</div>
		</div>
		<div class="card" v-if="dataReady">
			<div class="card-block">
				<div class="container" >
					<div class="row">
						<div class="comments col-md-12" id="comments">
							<div class="topic-title">
								<h3 class="clearfix">{{topic.title}}</h3>
								<div><span class="cat-badge" :style="'background-color:' + (topic.section.color || 'black')"></span> {{ topic.section.name }}</div>
							</div>


							<div class="comment mt-10 mb-2 row" v-for="(item, i) in topic.posts">
								<!-- comment -->
								<div class="comment-avatar col-md-1 col-sm-2 text-right pr-1">
									<c-uavatar :familyuser="item.author" :show-name="false"></c-uavatar>
								</div>
								<div class="comment-content col-md-11 col-sm-10">
									<h6 class="comment-meta">
										<router-link :to="item.author ? '/family/' + item.author.family : '#'" class="text-secondary" :title="item.author.name">{{ item.author.name }}</router-link>
										<small class="text-muted">&#9642;</small>
										<small class="text-muted" :title="item.createdAt | prettyDateTime">{{ item.createdAt | fromNowDateTime }}</small>
										<small class="text-muted" v-if="item.updatedAt != item.createdAt" :title="item.updatedAt | fromNowDateTime"><i class="fa fa-pencil"></i></small>
									</h6>
									<div class="comment-body">

										<div class="alert alert-danger" role="alert" v-if="item.editing && item.text != item.originalText">
											Това е само преглед; редактирания коментар все още не е записан.
											<a class="alert-link" @click="sendEdit(item)"><u>Натиснете тук за да запишете.</u></a>
										</div>

										<vue-markdown :source="item.text" :html="false"></vue-markdown>

										<div v-if="item.editing">
											<h4>{{$t('label.forum_edit')}}</h4>
											<f-textarea v-model="item.text" placeholder="Редактирайте вашия отговор" :crows="10">
											</f-textarea>
											Може да форматирате съобщението си като използвате <a href="http://commonmark.org/help/" target="_blank">markdown</a>.
											<div class="text-right">
												<button type="button" class="btn btn-primary mt-0" @click="toggleEdit(item)">Отмяна</button>
												<button type="button" class="btn btn-primary mt-0" @click="sendEdit(item)">Запис</button>
											</div>
										</div>

										<section class="post-menu-area clearfix">
											<nav class="post-controls clearfix">
												<div class="actions">
													<!-- <button v-show="item.likes" class="widget-button btn-flat like-count">{{ item.likes }}</button>
													<button class="widget-button btn-flat toggle-like like "><i class="fa fa-heart d-icon d-icon-d-unliked" aria-hidden="true"></i></button> -->
													<button class="widget-button btn-flat btn-danger" v-if="i != 0 && canDelete(item)" @click="deletePost(item)"><i class="fa fa-close" aria-hidden="true"></i></button>
													<button class="widget-button btn-flat btn-primary" v-if="canEdit(item)" @click="toggleEdit(item)"><i class="fa fa-edit" aria-hidden="true"></i></button>
													<button class="widget-button btn-flat btn-info" @click="addQuote(item)"><i class="fa fa-reply" aria-hidden="true"></i></button>
												</div>
											</nav>
										</section>
									</div>
								</div>
							</div>
							<!-- /comment -->

							<div class="row pt-2">
								<div class="col-md-1 col-sm-2 text-center pr-1">
									<c-uavatar :familyuser="$user.familyUser" :show-name="false" class="float-right"></c-uavatar>
								</div>
								<div class="col-md-11 col-sm-10">
									<h4>{{$t('label.forum_reply')}}</h4>
									<f-textarea v-model="pending.text" placeholder="Напишете вашия отговор" :crows="10" v-validate="'required'" :errors="errorBag.collect('forum_reply')">
									</f-textarea>
									Може да форматирате съобщението си като използвате <a href="http://commonmark.org/help/" target="_blank">markdown</a>.
									<button type="button" class="btn btn btn-primary pull-right mt-0" @click="sendReply">Отговор</button>
								</div>
							</div>

						</div>
					</div>
				</div>

			</div>
		</div>

	</div>
</div>
</template>

<script>
var VueMarkdown = require('vue-markdown').default;

module.exports = {
	data: function() {
		return {
			topic: {},
			dataReady: false,
			pending: {
				text: ''
			},
			error: false
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function () {
			this.$http.get('backend://topic/' + this.$route.params.id).then((result) => {
				this.topic = result.body;
				this.dataReady = true;
				this.error = false;
			}).catch(() => {
				this.dataReady = false;
				this.error = true;
			});
		},
		sendReply: function () {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				this.$http.post('backend://topic/' + this.$route.params.id, this.pending).then((result) => {
					this.fetchData();
					this.pending.text = '';
					process.nextTick(() => this.errorBag.clear());
				}).catch(this.$http.toastCatcher);
			});
		},
		sendEdit: function (item) {
			// TODO: validation here?
			this.$http.post('backend://topic/' + this.$route.params.id + '/' + item.id, item).then((result) => {
				this.$toasted.show('Успешен запис!').goAway(1500);
				item.editing = false;
				this.fetchData();
				process.nextTick(() => this.errorBag.clear());
			}).catch(this.$http.toastCatcher);
		},
		deletePost: function (item) {
			if (!confirm('Сигурни ли сте че искате да изтриете този пост?')) {
				return;
			}
			this.$http.delete('backend://topic/' + this.$route.params.id + '/' + item.id).then((result) => {
				this.$toasted.show('Успешно изтриване!').goAway(1500);
				this.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		deleteTopic: function (item) {
			if (!confirm('Сигурни ли сте че искате да изтриете тази тема?')) {
				return;
			}
			this.$http.delete('backend://topic/' + this.$route.params.id).then((result) => {
				this.$toasted.show('Успешно изтриване на темата!').goAway(1500);
				this.$router.go(-1);
			}).catch(this.$http.toastCatcher);
		},
		canDeleteTopic: function () {
			return this.$user.role === 'admin' || this.$user.role === 'moderator';
		},
		canDelete: function (item) {
			return this.$user.role === 'admin' || this.$user.role === 'moderator';
		},
		canEdit: function (item) {
			return item.author + '' === this.$user.familyUser.id + '' || this.$user.role === 'admin' || this.$user.role === 'moderator';
		},
		toggleEdit: function (item) {
			if (!item.editing) {
				this.$set(item, 'editing', true);
				this.$set(item, 'originalText', item.text);
			} else {
				item.editing = false;
				item.text = item.originalText;
				item.originalText = '';
			}
		},
		addQuote: function (item) {
			// this.pending.text +=
			this.pending.text += ('\n' + item.text.trim()).replace(/\n/g, '\n> ');
		}
	},
	components: {
		'vue-markdown': VueMarkdown
	}

};
</script>
<style>
.topic-title {
	border-bottom: 3px solid #e9ecef;
	margin-bottom: 10px;
}

.comment {
	border-bottom: 1px solid #e9ecef;
}

section.post-menu-area {
	position: relative;
	margin-bottom: 10px;
	margin-top: 20px;
}

nav.post-controls .actions {
	text-align: right;
	float: right;
	display: inline-block;
}

nav.post-controls button {
	font-size: 1.1em;
	padding: 8px 10px;
	vertical-align: top;
	background: transparent;
	border: none;
	margin-left: 3px;
}

nav.post-controls a,
nav.post-controls button {
	color: #bdbdbd;
	margin-right: 2px;
	display: inline-block;
}

nav.post-controls button.like:hover {
	color: #fa6c8d;
	background: #fee9ee;
}

nav.post-controls button.edit:hover {
	color: #ffffff;
	background: #ff9900;
}

.like-count {
	font-size: 0.9em !important;
}
</style>



// WEBPACK FOOTER //
// Topic.vue?4b136e1c